export const colors = {
  primary: {
    white: "#ffffff",
    gray: "#f3f3f9",
    darkerGray: "#d0d0d0",
    darkGray: "#828282",
    blue: "#1100fa",
    darkBlue: "#122138",
    green: "#27ae60",
    red: "#fa0000",
    orange: "#fa7800",
    warning: "#ffc302",
  },

  planning: {
    absence: "#dddbff",
    preComfort: "#ffe085",
    comfort: "#f6b870",
    night: "#b6b3ff",
    frostFree: "#b3daff",
    stop: "#e59e9f",
  },

  water: {
    cold: "#087bbe",
    colder: "#6DB7E3",
    hot: "#ff810a",
    highReturn: "#ffc302",
  },

  temperature: {
    cold: "#0066ff",
    medium: "#ffa800",
    hot: "#ff0600",
  },

  humidity: {
    dry: "#eccc5d",
    good: "#01b5dd",
    wet: "#455eb7",
  },

  airQuality: {
    perfect: "#32b541",
    good: "#15b325",
    average: "#e79a00",
    worse: "#e37101",
    bad: "#ce0404",
    veryBad: "#710139",
  },

  light: {
    dark: "#8b773f",
    medium: "#ffd577",
    bright: "#fff7c6",
  },

  openning: {
    closed: "#d099fa",
    half: "#9c2bf4",
    totally: "#6609b0",
  },

  role: {
    installer: "#fa7800",
    owner: "#27ae60",
    manager: "#2f80ed",
    visitor: "#fa00b4",
    api: "#00affa",
  },

  maintenance: {
    restartValve: "#0070c0",
    verifyGateway: "#ffeb9c",
    reviewValve: "#00b050",
    changeBattery: "#ffc000",
    replace: "#ff0000",
    uncloCheckRadioTransmission: "#ffc7ce",
    toInstall: "#ffff00",
  },

  /** Categorical chart order: brand-adjacent hues, consecutive ones kept far apart */
  /** Colorblind-safe categorical order: consecutive colors stay apart for every color vision */
  chart: {
    blue: "#2c5d98",
    green: "#87bb7b",
    indigo: "#505297",
    yellow: "#c29647",
    purple: "#743e78",
    teal: "#2da79b",
    orange: "#ab5d41",
    sky: "#67bae8",
    olive: "#716a00",
    rose: "#e58da1",
  },

  /** UI neutrals (admin heatmaps, AHU scheme panels, disabled controls) */
  neutral: {
    50: "#f8f9fa",
    100: "#f5f4f4",
    200: "#e5e7eb",
    300: "#d1d5db",
    400: "#9ca3af",
    500: "#6b7280",
    600: "#374151",
    700: "#1f2937",
    800: "#bdbdbd",
  },
} as const;
